import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';

/**
 * function markedOptionsFactory
 */
export function markedOptionsFactory(): MarkedOptions {

  const renderer = new MarkedRenderer();
  const linkRenderer = renderer.link;
  const imageRenderer = renderer.image;

  renderer.image = (href, title, text) => {
    const html = imageRenderer.call(renderer, href, title, text);

    const textSplited = text.split(':');
    const type = textSplited[0];

    let correctHref;
    if (type === 'image') {
      correctHref = text.split('image:')[1];
      return '<img class="zoom" src="' + correctHref + '" alt="" />';
    } else if (type === 'audio') {
      correctHref = text.split('audio:')[1];
      return `<audio
                 src="` + correctHref + `"
                 type="audio/mpeg"
                 style="width: 100%"
                 controls
              >
                  Your browser does not support the audio element.
              </audio>`
    } else if (type === 'video') {
      correctHref = text.split('video:')[1];
      return `<div class="video-container">
                <video
                    src="` + correctHref + `"
                    type="video/mp4"
                    controls
                >
                    Your browser does not support the video element.
                </video>
            </div>`;
    }

    return html;
  };

  renderer.link = (href, title, text) => {

    let html: string = '';
    if (text === '{video}') {
      if (href.includes('youtube')) {
        const youtubeVideoCode = href.split('watch?v=')[1].split('&')[0];

        html = `<div class="video-container embedded embedded-video" src="https://www.youtube.com/embed/` + youtubeVideoCode + `"></div>`;

      } else if (href.includes('vimeo')) {
        const vimeoVideoCode = href.split('vimeo.com/')[1];

        html = `<div class="video-container embedded embedded-video" src="https://player.vimeo.com/video/` + vimeoVideoCode + `"></div>`;

      } else {
        html = `<div class="video-container">
                <video
                    src="` + href + `"
                    type="video/mp4"
                    controls
                >
                    Your browser does not support the video element.
                </video>
            </div>`;
      }
    } else if (text === '{audio}') {
      html = `<audio
                 src="` + href + `"
                 type="audio/mpeg"
                 style="width: 100%"
                 controls
              >
                  Your browser does not support the audio element.
              </audio>`;
    } else if (text === '{image}') {
      html = `<img class="image center" width="100%" src="` + href + `" alt="image" />`;
    } else {
      html = linkRenderer.call(renderer, href, title, text);
      if (href.match('^((http|https)://)|(mailto:)')) {
        html = html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
      }
    }
    console.log('html', html);

    return html;
  };

  return {
    renderer: renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
    smartLists: true,
    smartypants: false,
  };
}
